import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData, Image, Spacing, TextInput } from '../../types'
import { CmsConverterService, defaultTextInput } from '../../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class TeaserBigVideoConverter extends CmsConverterService<TeaserBigVideoData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    const title = formData.st_title_text?.value
    const altText = formData.st_alt_text?.value
    const lazyLoad = formData.st_image_lazy_loading?.value
    return {
      videoId: formData.st_video ?? '',
      image: CmsConverterService.mapImage(formData.st_image, lazyLoad, altText, title),
      headline: formData.st_headline ?? defaultTextInput,
      text: formData.st_text ?? defaultTextInput,
      backgroundColor: formData.st_backgroundcolor?.value?.identifier ?? 'white',
      spacing: {
        top: formData.st_spacing_top?.value?.identifier ?? '',
        bottom: formData.st_spacing_bottom?.value?.identifier ?? ''
      },
      captionOverlay: formData.st_caption_text_overlay ?? defaultTextInput,
      descriptionOverlay: formData.st_description_text_overlay ?? defaultTextInput,
      switchVideoAndText: formData.st_switch_video_and_text?.value ?? false,
      headlineEmpty: formData.st_headline_empty?.value ?? false,
      textEmpty: formData.st_text_empty?.value ?? false
    } as TeaserBigVideoData
  }
}

export const TEASER_BIG_VIDEO_CONVERTER_TOKEN = new InjectionToken<Converter<CmsComponent, TeaserBigVideoData>>('TeaserBigVideoConverter')

export interface TeaserBigVideoData extends ConvertedComponentData {
  videoId: string;
  image: Image;
  headline: TextInput;
  text: TextInput;
  backgroundColor: string;
  spacing: Spacing;
  captionOverlay: TextInput;
  descriptionOverlay: TextInput;
  switchVideoAndText: boolean;
  headlineEmpty: boolean;
  textEmpty: boolean;
}
